module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1k8n8"))).then(() => parcelRequire('iDabs'));